module.exports = __webpack_public_path__ + "img/69600.cca6e420.jpg";